var a = /* @__PURE__ */ ((e) => (e.cafOperator = "#FF8D00", e.user = "#1246C8", e.finalized = "#00BB8C", e))(a || {});
export {
  a as WorkingTurnsColors
};
//# sourceMappingURL=palette.es.es.js.map
